import { asyncRoutes, constantRoutes } from '@/router'
import { getUserInfo } from '@/utils/auth'

/**
 * 使用meta.role确定当前用户是否具有权限
 * @param roles
 * @param route
 */
function hasPermission (roles, route) {
  var groupId = [getUserInfo().educationGroupId]
  var kindergartenId = [getUserInfo().kindergartenId]
  var userInfo = getUserInfo()
  var ret = true
  if (route.meta && route.meta.roles) {
    ret = ret && roles.some(role => route.meta.roles.includes(role))
    if (route.meta.groups) {
      ret = ret && groupId.some(groud => route.meta.groups.includes(groud))
    }
    if (route.meta.kindergartens) {
      ret = ret && kindergartenId.some(kindergarten => route.meta.kindergartens.includes(kindergarten))
    }
    if (route.meta.title === '托婴' || route.meta.title === 'Baby-sitting Section') {
      if (route.meta.babySit && route.meta.babySit.optionalFunction && route.meta.babySit.optionalFunction.isShowNursery) {
        ret = ret && route.meta.babySit.optionalFunction.isShowNursery
      } else {
        ret = false
      }
    }
    if (route.meta.title === '教案' || route.meta.title === 'Lesson Plans') {
      if (userInfo.optionalFunction && userInfo.optionalFunction.isHideTeachingPlan) {
        ret = false
      }
    }
    if (route.meta.title === '校外活动' || route.meta.title === 'Homeworks') {
      if (userInfo.optionalFunction && userInfo.optionalFunction.isHideHomework) {
        ret = false
      }
    }
    if (userInfo.roleId !== 6) {
      if (route.meta.title === '学生评量' || route.meta.title === 'Assessment') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideAssessment) {
          ret = false
        }
      }
      if (route.meta.title === '预设教案' || route.meta.title === 'Preset Lesson Plans') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHidePredesignTeachingPlan) {
          ret = false
        }
      }
      // if (route.meta.title === '培训资料管理') {
      //   if (userInfo.optionalFunction && userInfo.optionalFunction.isHidePredesignTeachingPlan) {
      //     ret = true
      //   } else {
      //     ret = false
      //   }
      // }
      if ((route.meta.title === '服药单' || route.meta.title === '保健医与学生绑定' || route.meta.title === 'Medications' || route.meta.title === '"Doctor & Student" Binding') && userInfo.roleId !== 7) {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideMed) {
          ret = false
        }
      }
      if (route.meta.title === '校车管理' || route.meta.title === '学生校车考勤' || route.meta.title === '校车老师与校车绑定' || route.meta.title === 'School Bus' || route.meta.title === '"Teacher & School Bus" Binding' || route.meta.title === 'School Bus Attendance') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideBus) {
          ret = false
        }
      }
      if (route.meta.title === '表格管理' || route.meta.title === 'Forms' || route.meta.title === '表格模板' || route.meta.title === 'Table Template') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isShowForm) {
          ret = ret && userInfo.optionalFunction.isShowForm
        } else {
          ret = false
        }
      }
      if (route.meta.title === '萤石监控设备管理') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isShowYsCamera) {
          ret = ret && userInfo.optionalFunction.isShowYsCamera
        } else {
          ret = false
        }
      }
      if (route.meta.title === '工资单' || route.meta.title === 'Payrolls') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isShowSalary) {
          ret = ret && userInfo.optionalFunction.isShowSalary
        } else {
          ret = false
        }
      }
      if (route.meta.title === '预缴学费管理' || route.meta.title === 'deposit') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isShowTuitionDeposit) {
          ret = ret && userInfo.optionalFunction.isShowTuitionDeposit
        } else {
          ret = false
        }
      }
      if (route.meta.title === '上海园园通学生关联') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isShowAge06) {
          ret = ret && userInfo.optionalFunction.isShowAge06
        } else {
          ret = false
        }
      }
      if (route.meta.title === '健康日报' || route.meta.title === 'Health Reports') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideEpidemicReport) {
          ret = false
        }
      }
      if (route.meta.title === '学费单' || route.meta.title === 'Tuition Fees') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideTuitionBill) {
          ret = false
        }
      }
      if (route.meta.title === '教学记录' || route.meta.title === 'Teaching Records') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideTeachingRecord) {
          ret = false
        }
      }
      if (route.meta.title === '学生作品' || route.meta.title === 'Arts & Crafts') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideStudentWork) {
          ret = false
        }
      }
      if (route.meta.title === '班级圈' || route.meta.title === 'Moments') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideClassCirclePhoto) {
          ret = false
        }
      }
      if (route.meta.title === '学生考勤' || route.meta.title === 'Student Attendance') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideSignIn) {
          ret = false
        }
      }
      if (route.meta.title === '假条补交' || route.meta.title === 'Absence Notes' || route.meta.title === '请销假') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideLeaveNote) {
          ret = false
        }
      }
      if (route.meta.title === '叮嘱' || route.meta.title === 'Notifications') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideEntrust) {
          ret = false
        }
      }
      if (route.meta.title === '关怀问候' || route.meta.title === 'Updates & Reminders') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideEntrust) {
          ret = false
        }
      }
    }
    if (userInfo.roleId !== 12) {
      if (route.meta.title === '业财对账' || route.meta.title === 'Reconciliation') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideAdmission) {
          ret = false
        }
      }
    }
    if (userInfo.roleId === 4) {
      if (route.meta.title === '财务' || route.meta.title === 'Finance') {
        if (userInfo.optionalFunction && userInfo.optionalFunction.isHideTuitionBill) {
          ret = false
        }
      }
    }
  }
  return ret
  // if (route.meta && route.meta.roles && route.meta.groups) {
  //   return roles.some(role => route.meta.roles.includes(role)) && groupId.some(groud => route.meta.groups.includes(groud))
  // } else if (route.meta && route.meta.roles && route.meta.kindergartens) {
  //   return roles.some(role => route.meta.roles.includes(role)) && kindergartenId.some(kindergarten => route.meta.kindergartens.includes(kindergarten))
  // } else if (route.meta && route.meta.roles) {
  //   return roles.some(role => route.meta.roles.includes(role))
  // } else {
  //   return true
  // }
}

/**
 * 按递归筛选异步路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes (routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes ({ commit }, roleId) {
    return new Promise(resolve => {
      let accessedRoutes
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roleId)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js